import { faPenToSquare } from "@fortawesome/free-solid-svg-icons/faPenToSquare";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { IItemOrcamento } from "app/types/IItemOrcamento";
import globalMU from "globalMU";
import React from "react";

const estiloLoteProduto = require("./produto-lote.module.scss").default;

export type DadosProdutosLote = {
  CodigoObjetoItemOrcamento?: number
  CodigoProduto?: string
  DescricaoProduto?: string
  Lotes?: PagedMessageResponse<Lotes>
  QuantidadePedida?: number
  QuantidadeReservada?: number
  ItensOrcamento?: IItemOrcamento[]
  UserMessage?: any
  Transforming?: boolean
}

export type Lotes = {
  Codigo: number
  CodigoBitola: string
  CodigoObjetoItemOrcamento: number
  DataFabricacao?: string
  Validade: any
  LoteVencido: boolean
  PermiteVendaLote: boolean
  DataLote?: string
  Filial: any
  LoteInterno: string
  Nome: string
  NomeBitola: string
  NomeTonalidade: string
  QuantidadeDisponivel: number
  QuantidadeOferta: number
  QuantidadeReservar: number
  VenderApenasSaldo: boolean
  VenderSaldoOferta: boolean
  UserMessage: any
  Transforming: boolean
}

export type ProdutoLoteProps = {
  dados: DadosProdutosLote;
  controlaValidade: boolean;
  mostrarNomeComoCodigo: boolean;
  onEditar: (lotes: Lotes) => void;
};

export const ProdutoLote = (props: ProdutoLoteProps) => {
  return (
    <>
      <div className={`_grid _grid-cols-[min-content_auto] _items-center ${estiloLoteProduto.tabelaProdutoLote}`}
        id="ProdutoLote_DadosLote">

        <label className={`_w-[200px] _mb-0 ${estiloLoteProduto.tableCellHeader}`}>Descrição</label>
        <div className={estiloLoteProduto.tableCellBody}>{props.dados?.DescricaoProduto}</div>

        <label className={`_w-[200px] _mb-0 ${estiloLoteProduto.tableCellHeader}`}>{props.mostrarNomeComoCodigo ? "Referência" : "Código"}</label>
        <div className={estiloLoteProduto.tableCellBody}>{props.dados?.CodigoProduto}</div>

        <label className={`_w-[200px] _mb-0 ${estiloLoteProduto.tableCellHeader}`}>Quantidade Pedida</label>
        <div className={estiloLoteProduto.tableCellBody}>{globalMU.formatarValorNumerico(props.dados?.QuantidadePedida, 3)}</div>

        <label className={`_w-[200px] _mb-0 ${estiloLoteProduto.tableCellHeader}`}>Quantidade Lançada</label>
        <div className={estiloLoteProduto.tableCellBody}>{globalMU.formatarValorNumerico(props.dados?.QuantidadeReservada, 3)}</div>

        <label className={`_w-[200px] _mb-0 ${estiloLoteProduto.tableCellHeader}`}>Quantidade Faltante</label>
        <div className={estiloLoteProduto.tableCellBody}>{globalMU.formatarValorNumerico(props.dados?.QuantidadePedida - Number(props.dados?.QuantidadeReservada?.toFixed(3)), 3)}</div>

      </div>

      <br /> 
      <div className="_overflow-x-auto">
      <div className={`_table _w-full _border-collapse" ${estiloLoteProduto.tabelaProdutoLote}`}
        id="ProdutoLote_tabela_Lote">
        <div className="_table-header-group">
          <div className="_table-row">
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}> Lote Interno</div>
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}>Lote</div>
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}>Tonalidade</div>
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}>Bitola</div>
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}>Fabricação</div>
            {props.controlaValidade && (
              <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}>Validade</div>
            )}
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`}>Vender Apenas Saldo</div>
            <div className={`_table-cell _text-right ${estiloLoteProduto.tableCellHeader}`}>Quantidade Disponível</div>
            <div className={`_table-cell _text-right ${estiloLoteProduto.tableCellHeader}`}>Quantidade a Reservar</div>
            <div className={`_table-cell _text-right ${estiloLoteProduto.tableCellHeader}`}>Quantidade em Oferta</div>
            <div className={`_table-cell ${estiloLoteProduto.tableCellHeader}`} />
          </div>
        </div>
        <div className="_table-row-group">
          {props.dados?.Lotes?.Entities?.map((entidade) => (
            <div key={entidade.Codigo} className="_table-row">
              <div className={`_table-cell _text-center ${estiloLoteProduto.tableCellBody}`}>{entidade.LoteInterno}</div>
              <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`}>{entidade.Nome}</div>
              <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`}>{entidade.NomeTonalidade}</div>
              <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`}>{entidade.NomeBitola}</div>
              <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`}>{globalMU.formatDate(entidade.DataFabricacao)}</div>
              {props.controlaValidade && (
                <>
                  <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`} style={{ color: entidade.LoteInterno ? 'red' : 'black' }}>{globalMU.formatDate(entidade?.Validade)}</div>
                </>
              )}
              <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`}>{entidade?.VenderApenasSaldo ? "Sim" : "Não"}</div>
              <div className={`_table-cell _text-right ${estiloLoteProduto.tableCellBody}`}>{globalMU.formatarValorNumerico(entidade?.QuantidadeDisponivel, 3)}</div>
              <div className={`_table-cell _text-right ${estiloLoteProduto.tableCellBody}`}>{globalMU.formatarValorNumerico(entidade?.QuantidadeReservar, 3)}</div>
              <div className={`_table-cell _text-right ${estiloLoteProduto.tableCellBody}`}>{globalMU.formatarValorNumerico(entidade?.QuantidadeOferta, 3)}</div>
              <div className={`_table-cell  ${estiloLoteProduto.tableCellBody}`}>
                {entidade?.PermiteVendaLote && (
                  <FontAwesomeIcon
                    cursor={"pointer"}
                    color="#3c8ac9"
                    fontSize={20}
                    icon={faPenToSquare}
                    onClick={(e) => props.onEditar(entidade)}
                  />
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
      </div>
      
      {<section style={{ marginBottom: "100px" }} />}
    </>
  );
};
